import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import { getRescueLevelTheme } from '../rescueLevel.theme';

export class DreamBubble extends View {
  private bubble: ImageScaleView;
  private dots: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      centerOnOrigin: true,
    });

    this.bubble = new ImageScaleView({
      superview: this,
      image: 'assets/minigame/rescueLevel/dream_bubble.png',
      scaleMethod: 'contain',
      width: downscale(321),
      height: downscale(264),
      centerOnOrigin: true,
    });

    this.dots = new ImageScaleView({
      superview: this,
      image: 'assets/minigame/rescueLevel/dream_bubble_dots.png',
      scaleMethod: 'contain',
      width: downscale(111),
      height: downscale(77),
      centerOnOrigin: true,
      x: -140,
      y: 20,
    });

    getRescueLevelTheme().getDream({
      superview: this.bubble,
      x: this.bubble.style.width / 2,
      y: this.bubble.style.height / 2,
    });

    this.setTick(this.tick.bind(this));
  }

  public tick() {
    const time = performance.now() / 1000;
    this.bubble.updateOpts({
      y: Math.sin(time * 2) * 5,
    });
    this.dots.updateOpts({
      y: 20 + Math.sin(time * 2 + 1) * 3,
    });
  }
}
